<template>
  <div class="checkout-cart-items">
    <div
      v-for="plan in plans"
      :key="'cart-item-' + plan.id"
      class="checkout-cart-item"
    >
      <div class="checkout-cart-item__top">
        <span class="checkout-cart-item__name">{{ plan.name }}</span>
        <button
          type="button"
          class="checkout-cart-item__remove"
          :disabled="processing"
          @click="$emit('remove', plan)"
        >
          Remover
        </button>
      </div>

      <div class="checkout-cart-item__bottom">
        <div v-if="canChangeQuantity(plan)" class="checkout-cart-item__qty">
          <span class="checkout-cart-item__qty-label">Quantidade</span>
          <div class="checkout-cart-item__qty-controls">
            <button
              type="button"
              class="checkout-cart-item__qty-btn"
              :disabled="processing || (plan.quantity || 1) <= 1"
              @click="changeQuantity(plan, (plan.quantity || 1) - 1)"
            >
              −
            </button>
            <input
              type="number"
              min="1"
              max="20"
              class="checkout-cart-item__qty-input"
              :value="plan.quantity || 1"
              :disabled="processing"
              @change="onQuantityInput(plan, $event)"
            />
            <button
              type="button"
              class="checkout-cart-item__qty-btn"
              :disabled="processing || (plan.quantity || 1) >= 20"
              @click="changeQuantity(plan, (plan.quantity || 1) + 1)"
            >
              +
            </button>
          </div>
        </div>
        <span class="checkout-cart-item__price">
          {{ linePrice(plan) | money(currencyCode || plan.currency_code) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    plans: {
      type: Array,
      default: () => []
    },
    currencyCode: {
      type: String,
      default: 'BRL'
    },
    processing: {
      type: Boolean,
      default: false
    },
    allowQuantity: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    canChangeQuantity(plan) {
      return this.allowQuantity && !plan.recurring;
    },
    unitPrice(plan) {
      const setup = parseFloat(plan.setup_fee) || 0;
      const fixed = parseFloat(plan.fixed_price) || 0;
      return setup > 0 ? setup : fixed;
    },
    linePrice(plan) {
      const quantity = parseInt(plan.quantity, 10) > 0 ? parseInt(plan.quantity, 10) : 1;
      return this.unitPrice(plan) * quantity;
    },
    changeQuantity(plan, quantity) {
      const next = Math.min(20, Math.max(1, parseInt(quantity, 10) || 1));
      if (next === (parseInt(plan.quantity, 10) || 1)) {
        return;
      }
      this.$emit('quantity-change', plan, next);
    },
    onQuantityInput(plan, event) {
      this.changeQuantity(plan, event.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-cart-items {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.checkout-cart-item {
  padding: 0.85rem 0.9rem;
  border-radius: 12px;
  background: rgba(92, 52, 152, 0.06);
  border: 1px solid rgba(92, 52, 152, 0.12);

  &__top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
    margin-bottom: 0.65rem;
  }

  &__name {
    font-weight: 600;
    color: #1f1630;
    line-height: 1.35;
    font-size: 0.92rem;
  }

  &__remove {
    border: none;
    background: none;
    padding: 0;
    color: #ea5455;
    font-size: 0.78rem;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      text-decoration: underline;
    }
  }

  &__bottom {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 0.75rem;
  }

  &__qty-label {
    display: block;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #6f6780;
    margin-bottom: 0.35rem;
  }

  &__qty-controls {
    display: inline-flex;
    align-items: center;
    border: 1px solid rgba(92, 52, 152, 0.18);
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
  }

  &__qty-btn {
    width: 32px;
    height: 34px;
    border: none;
    background: rgba(92, 52, 152, 0.08);
    color: #5c3498;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  &__qty-input {
    width: 42px;
    height: 34px;
    border: none;
    border-left: 1px solid rgba(92, 52, 152, 0.12);
    border-right: 1px solid rgba(92, 52, 152, 0.12);
    text-align: center;
    font-weight: 600;
    color: #1f1630;
    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &__price {
    font-weight: 700;
    color: #2c2c2c;
    white-space: nowrap;
  }
}
</style>
